import * as yup from "yup";

export const schema = yup
  .object({
    cep: yup.string().required("CEP é obrigatório"),
    street: yup.string().required("Rua é obrigatório"),
    neighborhood: yup.string().required("Bairro é obrigatório"),
    number: yup.string().optional(),
    completion: yup.string().required("Complemento é obrigatório"),
    reference: yup.string().optional(),
  })
  .required();

export type NewAddressFormData = yup.InferType<typeof schema>;
